module.exports = __webpack_public_path__ + "static/media/historial_propietarios.9b268a4d.svg";